import { useUserStore } from '@/stores/index.js';
import i18n from '@/locale/index.js';

// 提示框
export const toast = (title, options = {}) => {
    return new Promise((resolve, reject) => {
        //默认配置
        let config = {
            icon: 'none',
            image: '',
            mask: true,
            duration: 1500
        };
        //对象合并 新旧配置合并
        Object.assign(config, options);

        uni.showToast({
            title: String(title),
            ...config
        }).then(() => {
            setTimeout(resolve, config.duration);
        });
    });
};

//防抖
export function debounce(func, timeout = 300) {
    let timer;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
}

//节流
export function throttle(fn, mustDelay = 300) {
    let timer,
        start = 0;
    return function (...args) {
        let now = new Date().getTime();
        if (now > start + mustDelay) {
            fn.apply(this, args);
            start = now;
        }
    };
}

//路由
export const router = debounce((options = {}) => {
    if (typeof options === 'string') {
        uni.navigateTo({
            url: options,
            fail: (err) => {
                console.log(err);
            }
        });
    } else {
        const { url, delta } = options;
        switch (options.type) {
            case 'navigateTo':
                uni.navigateTo({
                    url
                });
                break;
            case 'redirectTo':
                uni.redirectTo({
                    url
                });
                break;
            case 'reLaunch':
                uni.reLaunch({
                    url
                });
                break;
            case 'switchTab':
                uni.switchTab({
                    url
                });
                break;
            case 'navigateBack':
                uni.navigateBack({
                    delta
                });
                break;
            default:
        }
    }
}, 300);

export function getUrlParams(variable, query) {
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return false;
}

// 数字单位
export function formatNumberUnit(number) {
    const SI_POSTFIXES = ['', 'k', 'M', 'B', 'T'];
    const tier = (Math.log10(Math.abs(number)) / 3) | 0;
    if (tier == 0) return number;
    const suffix = SI_POSTFIXES[tier];
    const scale = Math.pow(10, tier * 3);
    const scaled = number / scale;
    return scaled.toFixed(1) + suffix;
}

// 保留小数位（仅 toFixed，返回未带千分位的字符串，可安全参与后续计算/赋值）
export function fixedNumber(val, len = 2) {
    const num = Number(val);
    if (isNaN(num)) return val;
    return num.toFixed(len);
    //.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

// 韩股市场（KSE/KRX）或韩元币种（KRW），金额展示不保留小数
export function isKrMarket(market) {
    return ['KSE', 'KRX', 'KRW'].includes(market);
}

// 仅用于展示：在 fixedNumber 基础上加千分位 ","；当 market 为 KSE/KRX（或传入币种 KRW）时去掉小数部分。
// 注意：返回值是带逗号的字符串，禁止再参与算术计算（+str 会得到 NaN）。
export function formatNumber(val, len = 2, market) {
    const num = Number(val);
    if (isNaN(num)) return val;
    const fixedLen = isKrMarket(market) ? 0 : len;
    return num.toFixed(fixedLen).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// 保留小数位 不四舍五入
export function truncateNumber(number, digits) {
    const multiplier = Math.pow(10, digits);
    return Math.trunc(number * multiplier) / multiplier;
}

// 修改数据格式
export function formatModificationNumber(val, len = 0) {
    val = fixedNumber(val, len);
    if (!val) return 0;
    return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
// 修改金额对应市场
export function formatAmountToMarket(val, market) {
    return formatAmount(val, marketToLength(market));
}

//  修改金额
export function formatAmount(val, len = 2) {
    val = fixedNumber(val, len);
    return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function marketToLength(market) {
    switch (market) {
        case 'TSE':
            return 1;
        case 'KSE':
            return 0;
        default:
            return 3;
    }
}

// 国家货币
export function onCountryCurrency(currency) {
    switch (currency) {
        case 'JPY':
            return '円';
        case 'KRW':
            return '원';
        default:
            return currency;
    }
}

// 跳转客服
export function onCustomerService(cUrl = '', title = '') {
    const { t } = i18n.global;
    const userStore = useUserStore();
    const { email, phone, id, userName, customerServiceUrl } = userStore.userInfo;
    let url = cUrl || customerServiceUrl;
    if (!url) return;
    const params = {
        '[email]': email,
        '[phone]': phone,
        '[uid]': id,
        '[name]': userName
    };
    console.log(params);
    Object.keys(params).forEach((key) => {
        url = url.replace(key, params[key]);
    });
    // #ifdef H5
    // 判断如果有这个参数就跳转外部浏览器 不走webview
    if (url.includes('jump=1')) {
        window.location.href = url;
        return;
    }

    uni.navigateTo({
        url: `/pages/webview/index?url=${encodeURIComponent(url)}&title=${title || t('common.service')}`
    });
    // #endif

    // #ifdef APP-PLUS
    plus.webview.open(url);
    // #endif
}

// 新增一个方法，替换指定文本为另外一个文本，如果有才替换
export function replaceText(text, oldText, newText) {
    if (text && text.includes(oldText)) {
        return text.replace(oldText, newText);
    }
    return text;
}
